import React, { useEffect, useMemo } from "react";
import { RelayEnvironmentProvider } from "react-relay";
import { Route, type RouteComponentProps, Switch } from "react-router-dom";

import cx from "classnames";

import { environment } from "~/models";
import { ModalRoot } from "~/ui";

import PublicStream from "./PublicStream";
import Template from "./Template";

import "~/css/App.css";
import "~/css/media.css";
import "~/css/zindexes.css";
import "~/ui/legacy-text-styles.css";
import "~/ui/transitions.css";
import "~/ui/variables.css";

import styles from "./Public.module.css";

const MeetingRecording = React.lazy(() =>
	import("~/public/PublicMeetingRecap").then(module => ({
		default: module.PublicMeetingRecap,
	})),
);
const Clip = React.lazy(() =>
	import("~/meetingRecorder/TranscriptModal").then(module => ({ default: module.PublicClipModalRenderer })),
);

const Index: React.FunctionComponent<RouteComponentProps> = props => {
	const { url } = props.match;

	// Auth pages don't necessarily make GraphQL requests, so trigger
	// this manually to hide the loader.
	useEffect(() => {
		document.dispatchEvent(new CustomEvent("network-quiesced"));
	}, []);

	// On the public recap page we don't want the entire page to scroll, that component takes care of it's scrolling behaviour
	const publicRecapPage = useMemo(() => {
		return url.includes("/meeting_recordings/");
	}, [url]);

	return (
		<div className={cx(styles.pageWrapper, { [styles.overflowY]: !publicRecapPage })}>
			<RelayEnvironmentProvider environment={environment}>
				<ModalRoot>
					<Switch>
						<Route path={`${url}/templates/:templateGlobalKey/`} component={Template} />
						<Route path={`${url}/streams/:streamId/`} component={PublicStream} />
						<Route path={`${url}/meeting_recordings/:accessKey/:recordingId?`} component={MeetingRecording} />
						<Route path={`${url}/clips/:clipId/`} component={Clip} />
					</Switch>
				</ModalRoot>
			</RelayEnvironmentProvider>
		</div>
	);
};

export default Index;
